import Commons from '../../Services/Common/Common';

export const Login_Schema = {
  fields: {
    findIdForm: {
      userId: { initial: '', label: '사용자ID' },
      userNm: { initial: '', label: '성명', required: 'Y' },
      userTel: { initial: '', label: '전화번호', required: 'Y' },
      successful: { initial: false, label: '찾기성공여부' },
    },
    findPwForm: {
      userId: { initial: '', label: '사용자ID', required: 'Y' },
      userNm: { initial: '', label: '성명', required: 'Y' },
      userTel: { initial: '', label: '전화번호', required: 'Y' },
      userPw: { initial: '', label: '새 비밀번호', required: 'Y' },
      userPwConfirm: { initial: '', label: '비밀번호 확인', required: 'Y' },
      successful: { initial: false, label: '변경성공여부' },
    },
    agreement: {
      serviceUsingCheck: { initial: false, label: '서비스 이용 목적 동의' },
      serviceKindCheck: { initial: false, label: '서비스 종류 및 의무 동의' },
      personalInformationCheck: { initial: false, label: '개인정보 수집 동의' },
      transferAndCompensationCheck: {
        initial: false,
        label: '양도금지 및 손해배상 동의',
      },
      disclaimerCheck: { initial: false, label: '면책사항 동의' },
      allAgreeCheck: { initial: false, label: '전체 동의' },
    },
    signUpForm: {
      userNm: { initial: '', label: '성명', required: 'Y' },
      userPw: { initial: '', label: '비밀번호', required: 'Y' },
      userPwConfirm: { initial: '', label: '비밀번호 확인', required: 'Y' },
      userId: { initial: '', label: '아이디', required: 'Y' },
      userTel: { initial: '', label: '전화번호', required: 'Y' },
      userBirth: { initial: '', label: '생년월일', required: 'Y' },
      userBlood: { initial: '', label: '혈액형', required: 'Y' },
      userAddress1: { initial: '', label: '주소', required: 'Y' },
      userAddress2: { initial: '', label: '상세주소', required: 'Y' },
      userCustCd: { initial: '', label: '사업장코드', required: 'Y' },
      userDepCd: { initial: '', label: '부서코드', required: 'Y' },
      affiliationNm: { initial: '', label: '소속' },
      position: { initial: '', label: '직책' },
      rank: { initial: '', label: '직위', required: 'Y' },
      idDuplicationCheck: { initial: '', label: 'ID중복확인여부' },
      idDuplicationMsg: { initial: '', label: 'ID중복메시지' },
      userAuth: { initial: 'EMPLOYEE', label: '권한' },
      userPost: { initial: '', label: '우편번호' },
      userNation: { initial: '', label: '국적' },
      userType: { initial: 'EMPLOYEE', label: '사용자유형' },
      memberSignUpType: { initial: '', label: '회원가입유형' },
      // userEmTel: { initial: '', label: '비상연락처' },
      // userEmail1: { initial: '', label: '이메일ID' },
      // userEmail2: { initial: '', label: '도메인' },
      // emailCombo: { initial: 'jigjub', label: '이메일선택' },
      // userVisa: { initial: '', label: '비자상태' },

      authRegion: { initial: '', label: '권한지역' },
      userAuthDtl: { initial: '', label: '상세권한' },
      userCoCd: { initial: '', label: '회사코드' },

      careerYn: { initial: '0', label: '경력유무' },
      careerPeriod: { initial: '0', label: '경력기간' },

      identityConfirm: { initial: '', label: '본인인증여부' },
      identityErrMsg: { initial: '', label: '본인인증메시지' },
      isCanvasTrust: { initial: false, label: '서명여부' },
      successful: { initial: false, label: '가입성공여부' },
      realName: { initial: '', label: '실명인증성명' },
    },
    lists: {
      userTypeList: { initial: [] },
      bloodList: { initial: [] },
      nationList: { initial: [] },
      authList: { initial: [] },
      authDtlList: { initial: [] },
      careerList: { initial: [] },
    },
    loginForm: {
      userId: { initial: '', label: '사용자ID', required: 'Y' },
      userPw: { initial: '', label: '비밀번호', required: 'Y' },
      userIdKeep: { initial: false, label: '아이디 저장' },
      loginKeep: { initial: false, label: '자동 로그인' },
      lanCd: { initial: 'kr', label: '언어' },
    },
  },

  mapper: {
    search1: {
      Year: (_, context) => Commons.EncryptAES(context.search?.year ?? ''),
      Month: (_, context) => Commons.EncryptAES(context.search?.month ?? ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    search2: {
      Year: (_, context) => Commons.EncryptAES(context.search?.year ?? ''),
      Month: (_, context) => Commons.EncryptAES(context.search?.month ?? ''),
      UserId: (_, context) => Commons.EncryptAES(context.userId ?? ''),
    },
  },
};
